import { Hotkeys } from 'constants/Hotkeys';
import { EnumWithHotkey } from 'enums/EnumWithHotkey';

export enum SoftballHitTypes {
  GroundBall = 'GroundBall',
  LineDrive = 'LineDrive',
  FlyBall = 'FlyBall',
  Popup = 'Popup',
  Bunt = 'Bunt',
  SlapHit = 'SlapHit',
  Undefined = 'Undefined',
}

export const HitTypesHotkey: EnumWithHotkey = {
  GroundBall: {
    name: 'Ground Ball',
    value: SoftballHitTypes.GroundBall,
    keyCode: Hotkeys.HitType.GroundBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.GroundBall.hotkeyDisplay,
  },
  LineDrive: {
    name: 'Line Drive',
    value: SoftballHitTypes.LineDrive,
    keyCode: Hotkeys.HitType.LineDrive.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.LineDrive.hotkeyDisplay,
  },
  FlyBall: {
    name: 'Fly Ball',
    value: SoftballHitTypes.FlyBall,
    keyCode: Hotkeys.HitType.FlyBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.FlyBall.hotkeyDisplay,
  },
  Popup: {
    name: 'Popup',
    value: SoftballHitTypes.Popup,
    keyCode: Hotkeys.HitType.Popup.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.Popup.hotkeyDisplay,
  },
  Bunt: {
    name: 'Bunt',
    value: SoftballHitTypes.Bunt,
    keyCode: Hotkeys.HitType.Bunt.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.Bunt.hotkeyDisplay,
  },
  SlapHit: {
    name: 'Slap Hit',
    value: SoftballHitTypes.SlapHit,
    keyCode: Hotkeys.HitType.SlapHit.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.SlapHit.hotkeyDisplay,
  },
  Undefined: {
    name: 'Undefined',
    value: SoftballHitTypes.Undefined,
    keyCode: Hotkeys.HitType.Undefined.hotkeyCode,
    hotkeyDisplay: Hotkeys.HitType.Undefined.hotkeyDisplay,
  },
};
